import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function turnoAcompanhamento(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {

      case '@turnoacompanhamento/TURNOACOMPANHAMENTO_IN_REQUEST':
      case '@turnoacompanhamento/REFRESH': {
        draft.loading = true;
        break;
      }

      case '@turnoacompanhamento/SUCCESS_REMOVE':
      case '@turnoacompanhamento/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@turnoacompanhamento/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.turnoacompanhamentos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@turnoacompanhamento/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.turnoacompanhamento;
        break;
      }

      case '@turnoacompanhamento/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
